function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/* eslint-disable new-cap */
import { Cluster as olCluster, Vector as olSourceVector, TileDebug as olSourceTileDebug } from 'ol/source';
import { Vector as olLayerVector, Tile as olLayerTile } from 'ol/layer';
import olFormatGeoJSON from 'ol/format/GeoJSON';
import { tile as tileStrategyFactory } from 'ol/loadingstrategy';
import { createXYZ } from 'ol/tilegrid';
import { AbstractLayerHandler, LOADING_STATUS_VALUE } from './AbstractLayerHandler.ol';
import { RequestCounter } from './RequestCounter';
import olPoint from 'ol/geom/Point';
import olMultiPoint from 'ol/geom/MultiPoint';
import { LAYER_CLUSTER, WFS_ID_KEY } from 'oskari-frontend/bundles/mapping/mapmodule/domain/constants';
var MAP_MOVE_THROTTLE_MS = 2000;
var OPACITY_THROTTLE_MS = 1500;

/**
 * @class VectorLayerHandler
 * LayerHandler implementation for vector layers
 */
export var VectorLayerHandler = /*#__PURE__*/function (_AbstractLayerHandler) {
  function VectorLayerHandler(layerPlugin) {
    var _this;
    _classCallCheck(this, VectorLayerHandler);
    _this = _callSuper(this, VectorLayerHandler, [layerPlugin]);
    _this.loadingStrategies = {};
    return _this;
  }
  _inherits(VectorLayerHandler, _AbstractLayerHandler);
  return _createClass(VectorLayerHandler, [{
    key: "createEventHandlers",
    value: function createEventHandlers() {
      var _this2 = this;
      var handlers = _superPropGet(VectorLayerHandler, "createEventHandlers", this, 3)([]);
      if (this.plugin.getMapModule().getSupports3D()) {
        handlers['AfterChangeMapLayerOpacityEvent'] = Oskari.util.throttle(function (event) {
          return _this2._updateLayerStyle(event.getMapLayer());
        }, OPACITY_THROTTLE_MS);
        handlers['AfterMapMoveEvent'] = Oskari.util.throttle(function () {
          return _this2._loadFeaturesForAllLayers();
        }, MAP_MOVE_THROTTLE_MS);
      }
      return handlers;
    }
  }, {
    key: "addMapLayerToMap",
    value: function addMapLayerToMap(layer, keepLayerOnTop, isBaseMap) {
      _superPropGet(VectorLayerHandler, "addMapLayerToMap", this, 3)([layer, keepLayerOnTop, isBaseMap]);
      var opacity = this.plugin.getMapModule().getSupports3D() ? 1 : layer.getOpacity() / 100;
      var renderMode = 'hybrid';
      var visible = layer.isVisible();
      var source = this._createLayerSource(layer);
      var silent = true;
      var vectorLayer = new olLayerVector({
        opacity: opacity,
        visible: visible,
        renderMode: renderMode,
        source: source
      });
      var olLayers = [vectorLayer];

      // Setup clustering
      if (this._isClusteringSupported() && layer.getClusteringDistance()) {
        var clusterSource = new olCluster({
          distance: layer.getClusteringDistance(),
          source: source,
          geometryFunction: function geometryFunction(feature) {
            var geom = feature.getGeometry();
            if (geom instanceof olPoint) {
              return geom;
            }
            if (geom instanceof olMultiPoint && geom.getPoints().length === 1) {
              return geom.getPoint(0);
            }
            return null;
          }
        });
        var clusterLayer = new olLayerVector({
          opacity: opacity,
          visible: visible,
          source: clusterSource
        });
        vectorLayer.on('change:opacity', function () {
          return clusterLayer.setOpacity(vectorLayer.getOpacity());
        });
        clusterLayer.set(LAYER_CLUSTER, true, silent);
        olLayers.push(clusterLayer);
      }
      this.plugin.vectorFeatureService.registerHoverLayer(layer);
      this.plugin.setOLMapLayers(layer.getId(), olLayers);
      if (this.plugin.getMapModule().getSupports3D()) {
        this._loadFeaturesForLayer(layer);
      }
      return olLayers;
    }
  }, {
    key: "refreshLayer",
    value: function refreshLayer(layer) {
      if (!layer) {
        return;
      }
      var olLayers = this.plugin.getOLMapLayers(layer.getId());
      olLayers.forEach(function (olLayer) {
        var source = olLayer.getSource();
        if (!source) {
          return;
        }
        source.refresh();
      });
      this._loadFeaturesForLayer(layer);
    }

    /**
     * @private
     * @method _createLayerSource To get an ol vector source for the layer.
     * @param {Oskari.mapframework.bundle.mapwfs2.domain.WFSLayer} layer
     * @return {ol.source.Vector} vector layer source
     */
  }, {
    key: "_createLayerSource",
    value: function _createLayerSource(layer) {
      var map = this.plugin.getMapModule().getMap();
      var projection = map.getView().getProjection();
      var tileSize = (map.getSize() || [0, 0]).map(function (size) {
        return size > 1024 ? 1024 : size > 512 ? 512 : 256;
      });
      var tileGrid = createXYZ({
        extent: projection.getExtent(),
        tileSize: tileSize
      });
      var strategy = tileStrategyFactory(tileGrid);
      this.loadingStrategies['' + layer.getId()] = strategy;
      var source = new olSourceVector({
        format: new olFormatGeoJSON(),
        url: Oskari.urls.getRoute('GetWFSFeatures'),
        projection: projection,
        strategy: strategy
      });
      source.setLoader(this._getFeatureLoader(layer, source));
      return source;
    }

    /**
     * @method _createDebugLayer Helper for debugging purposes.
     * Use from console. Set breakpoint to _createLayerSource and add desired layer to map.
     *
     * Like so:
     * Set breakpoint on "const tileGrid = createXYZ({ ... });"
     * Call this._createDebugLayer(source)
     * @param {ol.source.TileDebug} source layer source
     */
  }, {
    key: "_createDebugLayer",
    value: function _createDebugLayer(tileGrid) {
      this.plugin.getMapModule().getMap().addLayer(new olLayerTile({
        source: new olSourceTileDebug({
          projection: this.plugin.getMapModule().getMap().getView().getProjection(),
          tileGrid: tileGrid
        })
      }));
    }

    /**
     * @private
     * @method _getFeatureLoader To get an ol loader impl for the layer.
     * @param {Oskari.mapframework.bundle.mapwfs2.domain.WFSLayer} layer
     * @param {ol.source.Vector} source
     * @return {function} loader function for the layer
     */
  }, {
    key: "_getFeatureLoader",
    value: function _getFeatureLoader(layer, source) {
      var _this3 = this;
      var counter = new RequestCounter();
      var updateLoadingStatus = function updateLoadingStatus(status) {
        counter.update(status);
        _this3.tileLoadingStateChanged(layer.getId(), counter);
      };
      return function (extent, resolution, projection) {
        updateLoadingStatus(LOADING_STATUS_VALUE.LOADING);
        jQuery.ajax({
          type: 'GET',
          dataType: 'json',
          data: {
            id: layer.getId(),
            srs: projection.getCode(),
            bbox: extent.join(',')
          },
          url: Oskari.urls.getRoute('GetWFSFeatures'),
          success: function success(resp) {
            var features = source.getFormat().readFeatures(resp);
            features.forEach(function (ftr) {
              return ftr.set(WFS_ID_KEY, ftr.getId());
            });
            source.addFeatures(features);
            updateLoadingStatus(LOADING_STATUS_VALUE.COMPLETE);
          },
          error: function error() {
            updateLoadingStatus(LOADING_STATUS_VALUE.ERROR);
            // mark failed loading so OL retries it later if map moves
            source.removeLoadedExtent(extent);
          }
        });
      };
    }

    /**
     * @private
     * @method _loadFeaturesForAllLayers Load features to all wfs layers.
     * Uses current map view's extent.
     */
  }, {
    key: "_loadFeaturesForAllLayers",
    value: function _loadFeaturesForAllLayers() {
      var _this4 = this;
      var mapView = this.plugin.getMap().getView();
      var extent = mapView.calculateExtent();
      var resolution = mapView.getResolution();
      var projection = mapView.getProjection();
      Oskari.getSandbox().findAllSelectedMapLayers().filter(function (lyr) {
        return _this4.layerIds.includes(lyr.getId());
      }).forEach(function (lyr) {
        return _this4._loadFeaturesForLayer(lyr, extent, resolution, projection);
      });
    }

    /**
     * @private
     * @method _loadFeaturesForLayer Loads features to the layer.
     *
     * Uses OpenLayers internal methods.
     * Load must be called manually in stacked 3D map mode.
     * (No target container defined for 3D view)
     *
     * @param {Oskari.mapframework.bundle.mapwfs2.domain.WFSLayer} lyr
     * @param {ol.Extent} extent (optional)
     * @param {Number} resolution (optional)
     * @param {ol.proj.Projection} projection (optional)
     */
  }, {
    key: "_loadFeaturesForLayer",
    value: function _loadFeaturesForLayer(lyr, extent, resolution, projection) {
      var _this5 = this;
      if (!extent) {
        var mapView = this.plugin.getMap().getView();
        extent = mapView.calculateExtent();
        resolution = mapView.getResolution();
        projection = mapView.getProjection();
      }
      var olLayers = this.plugin.getOLMapLayers(lyr.getId());
      if (olLayers.length === 0) {
        return;
      }
      olLayers.forEach(function (olLayer) {
        if (!_this5._shouldLoadFeatures(olLayer, resolution)) {
          return;
        }
        var strategy = _this5.loadingStrategies['' + lyr.getId()];
        strategy(extent, resolution).forEach(function (tileExt) {
          olLayer.getSource().loadFeatures(tileExt, resolution, projection);
        });
      });
    }
  }, {
    key: "_shouldLoadFeatures",
    value: function _shouldLoadFeatures(olLayer, resolution) {
      if (!olLayer.getVisible()) {
        return false;
      }
      return resolution <= olLayer.getMaxResolution() && resolution >= olLayer.getMinResolution();
    }
  }, {
    key: "_isClusteringSupported",
    value: function _isClusteringSupported() {
      return !this.plugin.getMapModule().getSupports3D();
    }
  }]);
}(AbstractLayerHandler);
;